import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    padding: 33px 33px 66px;
    background-color:  ${colors.light};
    flex: 1;

    .content-header {
      display: flex;
      align-items: center;

      p {
          font-family: Poppins, Heltica, Arial, sans-serif;
          border-radius: 50%;
          width: 56px;
          height: 56px;
          padding: 3px;
          font-size: 29px;  
          background: #fff;
          border: 4px solid #000;
          color: #000;
          text-align: center;
          font-weight: 600;
          margin-bottom: 8px;
        }
    }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color:  ${colors.grey};
        font-size: 17px;
        text-align: left;
    }

    @media screen and (max-width: 1919px) {
    padding: 33px 0 33px 31px;

    .content-header {
    
    p {
          font-family: Poppins, Heltica, Arial, sans-serif;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          padding: 3px;
          font-size: 21px;  
          background: #fff;
          border: 2px solid #000;
          color: #000;
          text-align: center;
          font-weight: 600;
          margin-bottom: 8px;
        }
    }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.grey};
        font-size: 14px;
        text-align: left;
        margin-top: 15px;
    }
  }
  @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 20px;
        padding: 18px 10px 18px;

        .content-header {
        p {
            width: 40px;
            height: 40px;
            font-size: 20px;  
            border: 2px solid #000;
            }
        }

        .content-body {
            min-height: 150px;
            max-height: 120px;
            font-size: 12px;
            margin-top: 15px;
        }
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {

        padding: 18px 10px 18px;

        .content-body {
            min-height: 0;
            max-height: 120px;
            font-size: 12px;
            margin-top: 15px;
        }
    }

`;
